var $table;
var pageSize;
var pageIndex;
$(document).ready(function(){
	
	$table = $("#transferResultTable");
	pageSize = 30;
	pageIndex = 0;
	
	$( document ).on( "transfer_filter_event", function( event ) {
		pageIndex=0;
		refreshTable();
	})
});

function getVisibleTransferCount(){
	return $table.find("div.item[data-visible=true]").length;
}

function getPageNum(){
	var visibleTransferCount = getVisibleTransferCount();
	if(visibleTransferCount == 0){
		$(".result-total").hide();
		$(".resultNotFound").show();	
	}else{
		$(".result-total").show();
		$(".resultNotFound").hide();	
	}
		
	return Math.ceil(visibleTransferCount / pageSize);
}

function refreshTable(){
	var pageNum = getPageNum();
	if(pageIndex > pageNum-1 || pageIndex < 0)
		return;
	
	$("#result-total").text(getVisibleTransferCount());
	var allRows = $('div.item');
	var visibleRows = $('div.item[data-visible=true]');

	$table.find(allRows).hide();
	$table.find(visibleRows).slice(pageSize * pageIndex,pageSize * (pageIndex + 1)).show();
}